
import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    inlineSwitch: {
        display: 'inline-block',
        marginRight: '10px'
    },
    switchLabel: {
        padding: '0 0 5px 0',
        color: '#fff'
    }
});

export default styles;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/CardSlider/CardContainer/Card/AdminControls/AdminSwitch/styles.js